/**
 * @file auth/msalInstance.js
 * @description Creates and exports the single shared PublicClientApplication (PCA) instance.
 *
 * Keeping the instance in its own module prevents circular imports:
 *  - main.jsx  needs it to initialize and render
 *  - api/client.js needs it to acquire tokens for API calls
 *  - Both can import from here without depending on each other
 *
 * Initialization (await msalInstance.initialize()) is intentionally NOT done here —
 * it must be awaited in main.jsx BEFORE ReactDOM.createRoot so MSAL is fully ready
 * before any component or hook runs.
 */

import { PublicClientApplication } from '@azure/msal-browser';
import { msalConfig } from './msalConfig';

/**
 * Shared MSAL PublicClientApplication instance.
 *
 * Do NOT call methods on this instance until `await msalInstance.initialize()`
 * has completed in main.jsx.
 *
 * @type {PublicClientApplication}
 */
const msalInstance = new PublicClientApplication(msalConfig);

export default msalInstance;
